// extracted by mini-css-extract-plugin
module.exports = {"advantageCardBackground":"AdvantageCard-module--advantage-card-background--2OYjO"};